import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Button, Item, Message, Placeholder, Popup, Table} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";
import {Project} from "../../models/project";
import {Document} from "../../models/document";
import {Icon} from "../../core/components/icon/icon";
import {DocumentForm} from "./document-form";
import {AppState} from "../../components/app/app-mobx";
import moment from "moment/moment";

export interface DocumentListProps {
    appStore: AppState;
    auftragsverwaltung: Auftragsverwaltung;
    project: Project;
    title?: string;
}
interface SortAction {
    type: string;
    column: string;
}
@observer
export class DocumentList extends Component<DocumentListProps, any> {
    watchHandles: any[] = [];
    constructor(props: DocumentListProps) {
        super(props);
        this.state = {
            isLoading: true,
            error: null,
            column: null,
            data: null,
            direction: null
        };
        this.sort = this.sort.bind(this);
        this.handleNewDocument = this.handleNewDocument.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState((state: any) =>({
                    data: state.data.reverse(),
                    direction: state.direction === "ascending" ? "descending" : "ascending"
                }));
            } else {
                this.setState((state: any) =>({
                    column: action.column,
                    data: _.sortBy(state.data, [action.column], ["asc"]),
                    direction: "ascending",
                }));
            }
            return;
        default:
            throw new Error();
        }
    }

    componentDidMount(): void {
        this.loadDocuments();
    }

    componentDidUpdate(): void {}
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }

    render(): React.ReactElement | null {
        const {appStore, auftragsverwaltung, project} = this.props;
        const {
            column, data, direction, isLoading, error
        } = this.state;

        if (isLoading) {
            return (
                <div>
                    <h3 id="react-arcgis-loading-text">Technische Dokumente laden...</h3>
                    <Placeholder>
                        <Placeholder.Header>
                            <Placeholder.Line/>
                        </Placeholder.Header>
                    </Placeholder>
                </div>
            );
        }

        if (error) {
            return (
                <Message negative>
                    <Message.Header>Fehler beim Laden der technischen Dokumente</Message.Header>
                    {error}
                </Message>
            );
        }

        const newDocumentButton = (
            <Popup content="Technisches Dokument hinzufügen"
                trigger={
                    <Button className={"new-document"} circular
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            const target = e.target as HTMLElement;
                            target.blur();

                            this.handleNewDocument(project);
                        }}>
                        <Icon name={"navigate_plus"} />
                    </Button>
                } />
        );

        let form: React.ReactElement | null = null;
        if (auftragsverwaltung.selectedDocument &&
            auftragsverwaltung.isEditingDocument) {
            form = (
                <DocumentForm
                    appStore={appStore}
                    auftragsverwaltung={auftragsverwaltung}
                    project={project}
                    onCancel={this.handleCancel}
                    onSave={() => this.handleSave() }
                />
            );
        }

        if (data.length === 0) {
            return (
                <>
                    {newDocumentButton}
                    {form}
                    <Item.Group className={"geo-documents"}>
                        <Item><Item.Content><p>keine technischen Dokumente</p></Item.Content></Item>
                    </Item.Group>
                </>
            );
        }

        return (
            <>
                {newDocumentButton}
                {form}
                <Item.Group className={"geo-documents"}>
                    <Item>
                        <Item.Content>
                            <Table basic="very" fixed singleLine sortable={(data.length > 1)} compact className={"documents"}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width={6} sorted={column === "label" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "label" })}>
                                            Anzeigename
                                        </Table.HeaderCell>
                                        <Table.HeaderCell sorted={column === "fileName" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "fileName" })}>
                                            Dateiname
                                        </Table.HeaderCell>
                                        <Table.HeaderCell sorted={column === "date" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "date" })}>
                                            Datum
                                        </Table.HeaderCell>
                                        <Table.HeaderCell sorted={column === "fileSize" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "fileSize" })}>
                                            Dateigrösse
                                        </Table.HeaderCell>
                                        <Table.HeaderCell></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {data.map((document: Document) => (
                                        <Table.Row key={document.objectId} >
                                            <Table.Cell width={6}>
                                                {document.label}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {document.fileName}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {moment(document.date).format("DD.MM.YYYY")}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {document.fileSize}
                                            </Table.Cell>
                                            <Table.Cell>
                                                <>
                                                    <Popup content="Technisches Dokument ändern"
                                                        trigger={
                                                            <Button className={"edit-document"} circular
                                                                onClick={(e: React.MouseEvent) => {
                                                                    e.preventDefault();
                                                                    const target = e.target as HTMLElement;
                                                                    target.blur();

                                                                    this.handleEdit(document);
                                                                }}>
                                                                <Icon name={"pencil"} />
                                                            </Button>
                                                        } />
                                                    <Popup content="Technisches Dokument löschen"
                                                        trigger={
                                                            <Button className={"edit-document"} circular
                                                                onClick={(e: React.MouseEvent) => {
                                                                    e.preventDefault();
                                                                    const target = e.target as HTMLElement;
                                                                    target.blur();

                                                                    this.handleDelete(document);
                                                                }}>
                                                                <Icon name={"garbage_can"} />
                                                            </Button>
                                                        } />
                                                </>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </>
        );
    }

    private handleNewDocument(project: Project): void {
        const {auftragsverwaltung, appStore} = this.props;

        if (!project.id) {
            return;
        }

        const user = appStore.esriCredential?.userId || "";
        auftragsverwaltung.DocumentStore.newItem(project.id, user).then(() => {
            // do not show map when editing
            auftragsverwaltung.setShowMap(false);
            auftragsverwaltung.setEditing(true, "document");
        });
    }

    private handleCancel(e: React.MouseEvent): void {
        e.preventDefault();
        const {auftragsverwaltung} = this.props;
        auftragsverwaltung.setEditing(false);
    }

    private handleEdit(document: Document): void {
        const {auftragsverwaltung} = this.props;

        // do not show map when editing
        auftragsverwaltung.setShowMap(false);
        auftragsverwaltung.DocumentStore.setSelectedItem(document);
        auftragsverwaltung.setEditing(true, "document");
    }

    private handleSave(): void {
        this.loadDocuments();
    }

    private handleDelete(document: Document): void {
        this.setState({
            isLoading: true
        });

        if (confirm("Technisches Dokument wirklich löschen?")) {
            const {appStore, auftragsverwaltung, project} = this.props;

            const user = appStore.esriCredential?.userId || "";
            auftragsverwaltung.DocumentStore.delete(project, document, user).then(() => {
                this.setState((state) => {
                    const data = state.data.filter((po) => po !== document);
                    return {
                        data,
                        isLoading: false
                    };
                });
            });
        }
    }

    private loadDocuments() {
        const {project, auftragsverwaltung} = this.props;

        if (!project || !project.id) {
            return;
        }

        auftragsverwaltung.DocumentStore.loadItems(project.id).then((documents: Document[]) => {
            const data = _.orderBy(documents, ["fileName"], ["asc"]);
            this.setState({
                data,
                column: "fileName",
                direction: "ascending",
                isLoading: false
            });
        }).catch((error) => {
            this.setState({
                error
            });
        });
    }

}
